<template>
  <section class="section page__content">

      <TheCommentBlock :comments="comments"
                       :value="commentValue"
                       @set-edit="setEdit"
                       @value-changed="setValue"
                       @create-comment="createComment"
                       :oldComment="oldComment"
                       @save-comment="saveComment"
                       @delete-comment="deleteComment"
                       @toggle-controls="toggleControls"
                       :disabled="!roleAccessEdit"
      />

  </section>
</template>

<script>
import TheCommentBlock from '@/components/page/TheCommentsBlock'
export default {
  name: 'PvhOrderUpdateComment',
  components: { TheCommentBlock },
  computed: {
    commentValue () {
      return this.$store.getters['pvhOrderUpdatePage/[pvh] getOrderUpdateCommentValue']
    },
    oldComment () {
      return this.$store.getters['pvhOrderUpdatePage/[pvh] getOrderUpdateOldCommentValue']
    },
    comments () {
      return this.$store.getters['pvhOrderUpdatePage/[pvh] getOrderUpdateComments']
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightPvh.actions.update
    }
  },
  methods: {
    setValue (value) {
      return this.$store.commit('pvhOrderUpdatePage/[pvh] SET_ORDER_UPDATE_COMMENT', value)
    },
    createComment () {
      return this.$store.dispatch('pvhOrderUpdatePage/[pvh] createOrderUpdateComment')
    },
    saveComment () {
      return this.$store.commit('pvhOrderUpdatePage/[pvh] SAVE_ORDER_UPDATE_COMMENT')
    },
    setEdit (value) {
      return this.$store.commit('pvhOrderUpdatePage/[pvh] SET_ORDER_UPDATE_EDIT_COMMENT', value)
    },
    deleteComment (value) {
      return this.$store.commit('pvhOrderUpdatePage/[pvh] DELETE_ORDER_UPDATE_COMMENT', value)
    },
    toggleControls (value) {
      return this.$store.commit('pvhOrderUpdatePage/[pvh] TOGGLE_ORDER_UPDATE_CONTROLS_COMMENT', value)
    }
  }
}
</script>

<style scoped>

</style>
